import Checkbox from "../../gui/Button/Checkbox"
import { UpdateEvent } from "../../gui/GUIEvents"
import Dot3Icon from "../../gui/Icons/Dot3Icon"
import { TMenuRow } from "../../gui/Menu/Menu"
import MenuButton from "../../gui/Menu/MenuButton"
import { usePath } from "../../libs/path/PathProvider"
import PortAccount from "../../models/PortAccount"
import PortUtils from "../../portlibs/PortUtils"
import AccountFilter from "./AccountFilter"
import SearchFilter from "./SearchFilter"

export type TToolbarProps = {
    children?:React.ReactNode
    options?:TMenuRow<string>[]
}
export default function Toolbar(props:TToolbarProps){
    const {query,setQuery} = usePath()
    const {showDisposed} = PortUtils.getFilter(query)
    const onLogout = () => {
        PortAccount.i.logout()
    }
    const MenuOptions : TMenuRow<string>[] = [
        ...(props.options||[]),
        {id:"logout",text:"Logout",onClick:onLogout}
    ]
    const onAll = (e:UpdateEvent<boolean>) => setQuery({show:e.value ? "1" : null})
    return <div className="toolbar flex middle gap-8">
        <AccountFilter/>
        <SearchFilter/>
        {props.children}
        <Checkbox value={showDisposed} onUpdate={onAll}>All</Checkbox>
        <MenuButton menuProps={{options:MenuOptions}} className="icon"><Dot3Icon/></MenuButton>
    </div>

}